/* eslint-env node, browser */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSpecialtyPlate } from '../../redux/modules/registration';
import specialtyPlates from '../../modules/data/specialty-plates';
import isSpecialPlateAllowed from '../../modules/isSpecialPlateAllowed';
import getPlateImageFromPlateName from '../../modules/getPlateImageFromPlateName';
import secondYearFeeTotal from '../../selectors/secondYearFeeTotal.selector';
import precise from '../../modules/precise';
import Dropdown from '../../components/Dropdown';

class SpecialtyPlate extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const value = event.target.value;
    let total = 0;

    // Is a special plate even allowed?
    if (!isSpecialPlateAllowed(this.props.selectedVehicleValue)) {
      alert('Special plates are not allowed on this vehicle type. Please update your Vehicle selection.');
      return;
    }

    if (value !== 'None') {
      const arySPECResults = value.split('|');
      // separate out field and property strings at quotation marks
      const SP0 = arySPECResults[0]; // Type Label
      const SP1 = Number(arySPECResults[1]); // Fees
      const SP2 = Number(arySPECResults[2]); // Additional Requirements

      if (SP2 === 2) {
        alert('This is actually a fee required, military service related (not specialty) plate that has additional requirements which MUST be supported by specific documentation; see Form 83034!');
      }

      // Breakdown the cName list into parts between commas
      // to get the tag code of the chosen plate.

      const arySpes = SP0.split(',');
      const name = arySpes[0]; // cNAME

      const fee = Number(arySpes.pop().replace('$', ''));

      if (SP1 === 17) {
        total += this.specialty(fee, 20.00);
      } else if (SP1 === 19) {
        total += this.specialty(fee, 22.00);
      } else if (SP1 === 22) {
        total += this.specialty(fee, 25.00);
      } else if (SP1 === 24) {
        total += this.specialty(fee, 27.00);
      } else if (SP1 === 25) {
        total += this.specialty(fee, 28.00);
      } else if (SP1 === 27) {
        total += this.specialty(fee, 30.00);
      } else {
        total = SP1;
      }

      this.props.setSpecialtyPlate({
        total: precise(total),
        specialtyPlateSelectedValue: value,
        specialtyPlateName: name,
        specialtyPlateImageName: getPlateImageFromPlateName(name),
      });
    } else {
      this.props.setSpecialtyPlate({
        total: precise(0),
        specialtyPlateSelectedValue: null,
        specialtyPlateName: null,
        specialtyPlateImageName: null,
      });
    }
  }

  getImage() {
    const { specialtyPlateImageName } = this.props;
    if (specialtyPlateImageName) {
      return <img className="SpecialPlate-img" src={`images/plates/${specialtyPlateImageName}`} alt={specialtyPlateImageName} />;
    }
    return null;
  }

  specialty(initialFee, addedFee) {
    const { applySecondYearFee } = this.props;
    const mts = Number(this.props.monthsFromNow);
    const secondYearFee = Number(this.props.secondYearFee);

    let total = initialFee;
    // var s7bv = thisGetField("Rsub7backup").val();
    // var s1c = thisGetField("Rsub1c");
    if (mts > 0 && mts <= 13) {
      total = addedFee;
    }
    if ((mts > 13) && (mts <= 15)) {
      total = addedFee * 2;
    }

    if (applySecondYearFee && secondYearFee !== 0) {
      total += addedFee;
    }

    return total;
  }

  plateCodesOnly(plateLabel) {
    let str = '';
    if (plateLabel) {
      const parts = plateLabel.split(',');
      const codes = parts.splice(1, parts.length - 2).join(', ');
      str = `(${codes})`;
    }
    return str;
  }

  render() {
    const { specialtyPlateTotal, specialtyPlateSelectedValue, specialtyPlateName } = this.props;
    return (
      <div className="Row Registration-specialtyPlateRow">
        <input tabIndex="-1" className="Row-total" id="Rsub7" data-tooltip="Specialty Plate Fees" type="text" value={specialtyPlateTotal} readOnly />

        <Dropdown
          initial={['No Specialty Plate', 'None']}
          id="SpecialtyPage"
          tooltip="Choose the type of Personalized Plate"
          options={specialtyPlates}
          onChange={this.onChange}
          selectedValue={specialtyPlateSelectedValue}
          className="Dropdown Row-dropdown no-print"
        />

        <div className="SpecialPlate" style={{ display: !specialtyPlateName || specialtyPlateName === '' ? 'none' : 'block' }}>
          <span className="SpecialPlate-super">{specialtyPlateName !== '' ? 'SPECIAL PLATE PREVIEW' : ''}</span>
          <span className="SpecialPlate-title">{specialtyPlateName}</span>
          <div className="SpecialPlate-imgFrame">{this.getImage()}</div>
        </div>

        <b className="print-label print-only">Specialty Plate {specialtyPlateName} {this.plateCodesOnly(specialtyPlateSelectedValue)}</b>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    specialtyPlateTotal: state.registration.specialtyPlateTotal,
    specialtyPlateSelectedValue: state.registration.specialtyPlateSelectedValue,
    specialtyPlateName: state.registration.specialtyPlateName,
    specialtyPlateImageName: state.registration.specialtyPlateImageName,
    monthsFromNow: state.registration.monthsFromNow,
    applySecondYearFee: state.registration.applySecondYearFee,
    secondYearFee: secondYearFeeTotal(state),
    selectedVehicleValue: state.registration.selectedVehicleValue,
  };
};

export default connect(mapStateToProps, { setSpecialtyPlate })(SpecialtyPlate);



// WEBPACK FOOTER //
// ./src/containers/registration/SpecialtyPlate.js